export var VehicleCondition;
(function (VehicleCondition) {
    VehicleCondition["VeryGood"] = "VeryGood";
    VehicleCondition["Good"] = "Good";
    VehicleCondition["Ok"] = "Ok";
})(VehicleCondition || (VehicleCondition = {}));
